export default __webpack_public_path__ + "static/media/vocalnet.4431df67.mp4";